module.exports = __webpack_public_path__ + "media/images/mission_bg_1-baaa881e006b2aaef170d2e2b80f43a8.svg";